// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3TN9c","modalContent":"Modal_modalContent__3mk7o","close":"Modal_close__2jmYT"};